import { List, ListItem, ListItemIcon, Theme, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import React from "react";

const quickTips = [
  "Simple searches, like a partial name instead of a whole, will produce more results.",
  "Reduce typing by taking advantage of auto-complete suggestions.",
  "All fields are optional. You do not need to fill in every line.",
  "You can narrow your focus for highly targeted searches. The more input you give, the fewer results you’ll receive.",
  "Adjust your search input if you’re not getting the results you expected.",
];

const useStyles = makeStyles((theme: Theme) => ({
  MuiSvgIcon: {
    color: theme.palette.primary.main,
    fontSize: "10px",
  },
  quickTips: {
    "margin": "0 .5rem",
    "& div": {
      minWidth: 20,
    },
    "& ul": {
      "padding": 0,
      "& li": {
        padding: "0px .875rem",
        marginBottom: ".875rem",
      },
    },
  },
  tips: {
    fontSize: "1rem",
  },
}));

export default function QuickTips() {
  const classes = useStyles();
  return (
    <div className={classes.quickTips} id={"quick-tips"}>
      <Typography variant="h2">Quick Tips:</Typography>
      <List>
        {quickTips.map((tip, index) => (
          <ListItem key={index}>
            <ListItemIcon>
              <FiberManualRecordIcon className={classes.MuiSvgIcon} />
            </ListItemIcon>
            <Typography className={classes.tips}>{tip}</Typography>
          </ListItem>
        ))}{" "}
      </List>
    </div>
  );
}
